import accountApi from "./account";
import adminApi from "./admin";
import connectionApi from "./connection";
import authApi from "./auth";
import inviteApi from "./invite";
import reportApi from "./report";
import requestApi from "./request";
import subscriptionApi from "./subscription";
import userApi from "./user";

const api = {
    accountApi,
    adminApi,
    connectionApi,
    authApi,
    inviteApi,
    reportApi,
    requestApi,
    subscriptionApi,
    userApi,
}

export default function useApi() {
    return api;
}